module.exports = __webpack_public_path__ + "static/media/covers2.e4553402.jpg";